import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=fb42fafe&"
import script from "./Cities.vue?vue&type=script&lang=js&"
export * from "./Cities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports